module.exports = __webpack_public_path__ + "img/icon-home-ev-04.d20e1511.png";